import React from 'react'

import header from './../../../UI/general/Mobile/header.png'
import logoAuteco from './../../../UI/logos/logo-auteco.svg'

import fullOff from './../../../UI/general/Header/full-off.svg'
import fullOn from './../../../UI/general/Header/full-on.svg'

import audioOff from './../../../UI/general/Header/audio-off.svg'
import audioOn from './../../../UI/general/Header/audio-on.svg'

interface Props{
    handleToogleMenu: any,
    isMenuOpened: boolean,
    isFullScreen: boolean,
    isMuted: boolean,
    handleFullScreen: any
    handleAudio: any
}

interface State{
    isSettingsOpened: boolean 
}

class HeaderMobile extends React.Component<Props,State>{
    constructor(props: Props){
        super(props);
        this.state = {
            isSettingsOpened: false
        } 
    }

    handleToogleSettingsMenu = () => {
        this.setState({
            isSettingsOpened: !this.state.isSettingsOpened
        })
    }

    render(){
        return(
            <React.Fragment>
                <div className='header-component-mobile'>
                    <img src={header} className='header-image-mobile'/>
                    <img src={logoAuteco} className='header-logo-mobile'/>
                    <div className='menu-btn-container-mobile' onClick={() => {this.props.handleToogleMenu()}}>
                        <div className={this.props.isMenuOpened ? 'line-mobile top-line-selected-mobile':'line-mobile top-line-mobile'}></div>
                        <div className={this.props.isMenuOpened ? 'line-mobile middle-line-selected-mobile':'line-mobile middle-line-mobile'}></div>
                        <div className={this.props.isMenuOpened ? 'line-mobile bottom-line-selected-mobile':'line-mobile bottom-line-mobile'}></div>
                    </div>
                    <div className='settings-container-mobile' onClick={() => {this.handleToogleSettingsMenu()}}>
                        <div className='dot-mobile'/>
                        <div className='dot-mobile'/>
                        <div className='dot-mobile'/>
                    </div>
                </div>
                {
                <div className={this.state.isSettingsOpened ? "settings-opened-mobile":"settings-collapsed-mobile"}>
                    {
                        this.state.isSettingsOpened ?
                        <React.Fragment>
                            <div className='setting-container-mobile'></div>
                            <div className='setting-container-mobile' onClick={() => {this.props.handleFullScreen()}}>
                                <img src={this.props.isFullScreen ? fullOn:fullOff} />
                            </div> 
                            <div className='setting-container-mobile' onClick={() => {this.props.handleAudio()}}>
                                <img src={this.props.isMuted ? audioOff:audioOn} />
                            </div>
                        </React.Fragment>: null
                    }
                </div>
                }
            </React.Fragment>
        )
    }
}

export default HeaderMobile